import { topSafeHeight } from "./platform";

export { topSafeHeight };
